import { BaseModel } from '../../models/base.model';

export class StoreStatus extends BaseModel {
  exists: boolean;
  usable: boolean;
  taxable: boolean;
  upfront_amount_on_sale_item_enabled: boolean;
}
